import { EFrequency } from "./enum/frequency";
import { EPresenceType } from "./enum/presence-type";
import { ESubSectionType } from "./enum/sub-section-type";
import { EWorkType } from "./enum/work-type";

export class Work {
    constructor() {

    }

    IsMixed: boolean;

    SubSection: ESubSectionType;
    Type: EWorkType;
    StartDate: Date;
    WorkDuration: number;
    WorkPeriodicity: EFrequency;
    RemovalDuration: number;
    RemovalPeriodicity: number;
    Coactivity: EPresenceType;
    NumberOfOperators: number;
    NumberOfSiteSupervisors: number;
    NumberOfTechnicalSupervisors: number;

    InvestigationScopes: string[] = [];

    // Counters
    ClientMPCAsNumber: number;
    OtherMPCAsNumber: number;
    InvestigationScopesNumber: number;
    HasOtherMPCA: EPresenceType;

    // FDX
    HasNormalRoomUsage: boolean
    HasFollowingIncident: boolean
    HasBeforeWork: boolean
    // HasPreliminaryWork: boolean
    HasDuringWorkOperator: boolean
    HasDuringWorkEnvironmental: boolean
    // HasPostWork: boolean
    HasEndOfAsbestosWork: boolean
    HasEndOfAsbestosWork2: boolean
    HasEndOfAsbestosProcessingWork: boolean

    static mapFromJSON(json): Work {
        const w = new Work;

        w.IsMixed = json['isMixed'];
        w.SubSection = json['subSection'];
        w.Type = json['type'];
        if (json['startDate']) {
            w.StartDate = new Date(json['startDate']);
        }
        w.WorkDuration = json['workDuration'];
        w.WorkPeriodicity = json['workPeriodicity'];
        w.RemovalDuration = json['removalDuration'];
        w.RemovalPeriodicity = json['removalPeriodicity'];
        w.Coactivity = json['coactivity'];
        w.NumberOfOperators = json['numberOfOperators'];
        w.NumberOfSiteSupervisors = json['numberOfSiteSupervisors'];
        w.NumberOfTechnicalSupervisors = json['numberOfTechnicalSupervisors'];

        w.InvestigationScopes = json['investigationScopes'];

        w.HasOtherMPCA = json['hasOtherMPCA'];

        w.ClientMPCAsNumber = json['clientMPCAsNumber'];
        w.OtherMPCAsNumber = json['otherMPCAsNumber'];
        w.InvestigationScopesNumber = json['investigationScopesNumber'];

        // FDX
        w.HasNormalRoomUsage = json['hasNormalRoomUsage'];
        w.HasFollowingIncident = json['hasFollowingIncident'];
        w.HasBeforeWork = json['hasBeforeWork'];
        // w.HasPreliminaryWork = json['hasPreliminaryWork'];
        w.HasDuringWorkOperator = json['hasDuringWorkOperator'];
        w.HasDuringWorkEnvironmental = json['hasDuringWorkEnvironmental'];
        // w.HasPostWork = json['hasPostWork'];
        w.HasEndOfAsbestosWork = json['hasEndOfAsbestosWork'];
        w.HasEndOfAsbestosWork2 = json['hasEndOfAsbestosWork2'];
        w.HasEndOfAsbestosProcessingWork = json['hasEndOfAsbestosProcessingWork'];

        return w;
    }
}
